$(document).ready(function () {

    if ($('#config-item').length < 1) {
        return;
    }

    var ConfigItemList = Ractive.extend({

        template: '#config-item',
        data:  function() {
            return {
                configItems: [],
                configScope: window.configScope,
                currentGroup: window.currentGroup,
                newItem: {
                    config_group: "",
                    scope : window.configScope,
                    label: "",
                    value: ""
                }
            }

        },
        oncomplete: function () {
            $('tbody[data-role="config-items-list"] tr[data-role="inline-item-editor"]').inlineContentEditor();
        },
        saveItem: function () {
            $.ajax({
                url: "/config/" + (this.get("configScope")),
                type: "post",
                dataType: "json",
                data: {
                    configItem: this.get('newItem')
                }
            });
            this.push('configItems', this.get('newItem'));
            this.resetItem();
        },
        resetItem: function () {
            this.set('newItem', {
                config_group: "",
                label: "",
                value: ""
            });
        }

    });
    var configItemsList = new ConfigItemList({

        el: $('tbody[data-role="config-items-list"]:first'),
        data: function () {
            return {
                configItems: window.configItems,
                configScope: window.configScope,
                currentGroup: window.currentGroup
            }
        }

    });

    var configGroupSelect = new Ractive({

        el : $('[data-role="config-group-filter"]'),
        template : $('[data-role="config-group-filter"]').html()

    });
   
});